import { render, staticRenderFns } from "./statisticsVote.vue?vue&type=template&id=27139dbc&scoped=true"
import script from "./statisticsVote.vue?vue&type=script&lang=js"
export * from "./statisticsVote.vue?vue&type=script&lang=js"
import style0 from "./statisticsVote.vue?vue&type=style&index=0&id=27139dbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27139dbc",
  null
  
)

export default component.exports